import { useState } from 'react';
import { fixNumbers, unhandledErrorGenerator, useRequest } from '@rahtab/auth/lib/token-based-auth';
import moment from 'moment-jalaali';
import { useAlert } from '@rahtab/ui';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const useSubmitProduct = () => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [numOfProducts, setNumOfProducts] = useState(0);
  const alert = useAlert();
  const request = useRequest();
  const addSaleHistory = async (product: Item) => {
    const username = await AsyncStorage.getItem('username');
    const saleHistory = await AsyncStorage.getItem(`${username}-saleHistory`);
    let history: Item[] = [];
    if (saleHistory !== null) {
      history = JSON.parse(saleHistory);
      history.forEach((item: any, index: number) => {
        if (moment().diff(item.date, 'days') > 14) {
          history.splice(index, 1);
        }
      });
    }
    history.push(product);
    try {
      await AsyncStorage.setItem(`${username}-saleHistory`, JSON.stringify(history));
    } catch (e) {
      alert({ title: 'خطا', message: 'مشکلی در ذخیره اطلاعات پیش آمده است.' });
    }
  };

  const submitProduct = async (
    customerName: string,
    imageUrl: string,
    itemName: string,
    id: string,
    amount: string,
    measure: string,
    price: string,
    latitude: number,
    longitude: number,
  ) => {
    setSubmitLoading(true);
    try {
      const submit = await request<SubmitValidation>('SubmitSale', {
        params: `ItemCode=${id}&Latitude=${latitude}&Longitude=${longitude}&Amount=${parseFloat(
          fixNumbers(amount),
        )}&Price=${price}`,
      });
      if (submit.valid === 'true') {
        setSubmitLoading(false);
        const submitDate = moment(submit.date, 'MM/DD/YYYY').format('jYYYY/jMM/jDD');
        const time = moment().format('HH:mm');
        addSaleHistory({
          id,
          imageUrl,
          itemName,
          itemAmount: amount,
          measure,
          price: parseFloat(price).toLocaleString('en'),
          date: submitDate,
          time,
          customerName,
        });
        setNumOfProducts(numOfProducts + 1);
        alert({ title: 'پیام سیستم', severity: 'success', message: 'کالا با موفقیت ثبت شد.' });
      } else if (submit.valid === 'false') {
        setSubmitLoading(false);
        if (submit.error) {
          if (submit.error === 'quota_max_quantity_each_time') {
            alert({ title: 'خطا', message: 'مقدار وارد شده از مقدار مجاز این نوبت از خرید، بیشتر میباشد.' });
          } else if (submit.error === 'quota_received') {
            alert({ title: 'خطا', message: 'این کالا دریافت شده است.' });
          } else if (submit.error === 'stock_not_enough') {
            alert({ title: 'خطا', message: ' موجودی کالا کافی نمیباشد.' });
          } else if (submit.error === 'quota_allowed_times') {
            alert({ title: 'خطا', message: 'تعداد دفعات ثبت این کالا برای این مشتری تمام شده است.' });
          } else if (submit.error === 'quota_quantity') {
            alert({ title: 'خطا', message: 'مقدار وارد شده، بیش از سهمیه خریدار میباشد.' });
          } else if (submit.error === 'invalid_quantity') {
            alert({ title: 'خطا', message: 'مقدار وارد شده نامعتبر است.' });
          } else if (submit.error === 'no_quotas') {
            alert({ title: 'خطا', message: 'سهمیه‌ای برای کالای انتخاب شده وجود ندارد.' });
          } else if (submit.error === 'provider_not_found') {
            alert({ title: 'خطا', message: 'اطلاعات پذیرنده برای ثبت فروش کافی نیست. اطفا با پشتیبانی تماس بگیرید.' });
          } else {
            alert(unhandledErrorGenerator(101));
          }
        } else {
          alert(unhandledErrorGenerator(508));
        }
      } else {
        alert(unhandledErrorGenerator(509));
      }
    } catch (err) {
      setSubmitLoading(false);
    }
  };
  return { submitLoading, submitProduct, numOfProducts };
};

interface SubmitValidation {
  valid: string;
  date: string;
  error: string;
}
interface Item {
  id: string;
  imageUrl: string;
  itemName: string;
  itemAmount: string;
  measure: string;
  price: string;
  date: string;
  time: string;
  customerName: string;
}
